var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "custom-calendar-with-events" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("FullCalendar", {
              ref: "calendar",
              attrs: { options: _vm.calendarOptions },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "events-list" }, [
            _c("h2", { staticClass: "events-list__title" }, [_vm._v("Events")]),
            _vm._v(" "),
            _vm.selectedDate
              ? _c(
                  "div",
                  { staticClass: "events-list__selected-date-wrapper" },
                  [
                    _c("div", { staticClass: "events-list__selected-date" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$moment(_vm.selectedDate).format("MMMM Do YYYY")
                          ) +
                          "\n                            "
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "events-list__selected-date-dismiss",
                          on: { click: _vm.onSelectedDateDismissClick },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "800px",
                                height: "800px",
                                viewBox: "0 0 24 24",
                                fill: "#ffffff",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "fill-rule": "evenodd",
                                  "clip-rule": "evenodd",
                                  d: "M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z",
                                  fill: "#1755b6",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "events-list__list" },
              _vm._l(_vm.filteredEvents, function (event) {
                return _c("li", { staticClass: "event-item" }, [
                  _c("div", { staticClass: "cel-event" }, [
                    _c("div", { staticClass: "cel-event__date" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$moment(event.start).format("MMM"))),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$moment(event.start).format("DD"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cel-event__box" }, [
                      event.url
                        ? _c("h3", { staticClass: "cel-event__title" }, [
                            _c("a", { attrs: { href: event.url } }, [
                              _vm._v(_vm._s(event.title)),
                            ]),
                          ])
                        : _c("h3", { staticClass: "cel-event__title" }, [
                            _vm._v(_vm._s(event.title)),
                          ]),
                      _vm._v(" "),
                      _c("time", { staticClass: "cel-event__date-string" }, [
                        _vm._v(_vm._s(event.dateString)),
                      ]),
                    ]),
                  ]),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _vm._m(0),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "events-list__link-wrapper" }, [
      _c("a", { staticClass: "button", attrs: { href: "/calendar" } }, [
        _vm._v("View Calendar"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }